import { render, staticRenderFns } from "./FreddiesShop.vue?vue&type=template&id=a465535c&scoped=true&"
import script from "./FreddiesShop.vue?vue&type=script&lang=js&"
export * from "./FreddiesShop.vue?vue&type=script&lang=js&"
import style0 from "./FreddiesShop.vue?vue&type=style&index=0&id=a465535c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a465535c",
  null
  
)

export default component.exports